import { render } from "./Soundboard.vue?vue&type=template&id=1357e75e&scoped=true&ts=true&lang=html"
import script from "./Soundboard.vue?vue&type=script&lang=ts"
export * from "./Soundboard.vue?vue&type=script&lang=ts"

import "./Soundboard.vue?vue&type=style&index=0&id=1357e75e&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1357e75e"]])

export default __exports__